import React from 'react';

/**
 * MUI's Grid item xs/sm are column-spans out of 12; antd's Row/Col use a
 * 24-column grid. Doubling the span keeps every field the same visual width
 * it had before, without touching the field-config objects these SR forms
 * already pass around (xs/sm values stay expressed in the original 12-col terms).
 */
export const toAntdSpan = (muiSpan?: number): number | undefined =>
  typeof muiSpan === 'number' ? muiSpan * 2 : undefined;

export const fieldColProps = (field: any) => ({
  xs: toAntdSpan(field.xs) ?? 24,
  sm: toAntdSpan(field.sm),
  style: {
    padding: 8,
    display: field.isHidden ? 'none' : field.display,
  } as React.CSSProperties,
});

export const labelStyle: React.CSSProperties = {
  display: 'block',
  fontSize: 17,
  fontWeight: 'bold',
};
